import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4403898e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h2", { class: "title content-title" }, "著者関連資料")
], -1))
const _hoisted_2 = {
  key: 0,
  class: "area-searchResult"
}
const _hoisted_3 = { class: "content has-background-contents shadow" }
const _hoisted_4 = { class: "the-search-result-main-nav is-hidden-mobile level-right has-background-contents" }
const _hoisted_5 = ["onClick", "onKeydown"]
const _hoisted_6 = { class: "item-list-view-rights" }
const _hoisted_7 = { class: "app-label-places level-left" }
const _hoisted_8 = { class: "item-list-view-permission-text" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "no-result" }, "著者関連資料は見つかりませんでした。", -1))
const _hoisted_11 = [
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppSelect = _resolveComponent("AppSelect")!
  const _component_AppIconPlaces = _resolveComponent("AppIconPlaces")!
  const _component_Table = _resolveComponent("Table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (_ctx.worksList.length !== 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("nav", _hoisted_4, [
              _createVNode(_component_AppSelect, {
                modelValue: _ctx.sortSelected,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.sortSelected) = $event)),
                options: _ctx.sortList,
                class: "select-sort"
              }, null, 8, ["modelValue", "options"])
            ]),
            _createElementVNode("div", null, [
              _createVNode(_component_Table, {
                header: _ctx.header,
                className: 'contents'
              }, {
                default: _withCtx(() => [
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.worksList, (data, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", null, [
                          _createElementVNode("button", {
                            onClick: ($event: any) => (_ctx.router.push(`/${_ctx.makeUpdatedPidString(data.pid)}`)),
                            onKeydown: _withKeys(_withModifiers(($event: any) => (_ctx.router.push(`/${_ctx.makeUpdatedPidString(data.pid)}`)), ["prevent"]), ["space","enter"]),
                            class: "button-itemDetail"
                          }, [
                            _createElementVNode("a", null, _toDisplayString(_ctx.makeUpdatedPidString(data.pid)), 1)
                          ], 40, _hoisted_5)
                        ]),
                        _createElementVNode("td", null, _toDisplayString(data.title), 1),
                        _createElementVNode("td", null, _toDisplayString(data.attribute), 1),
                        _createElementVNode("td", null, _toDisplayString(data.publicationPlace), 1),
                        _createElementVNode("td", null, _toDisplayString(data.publisher), 1),
                        _createElementVNode("td", null, _toDisplayString(data.issued) + "年", 1),
                        _createElementVNode("td", _hoisted_6, [
                          _createElementVNode("div", _hoisted_7, [
                            _createVNode(_component_AppIconPlaces, {
                              type: _ctx.permissionType(data.permission)
                            }, null, 8, ["type"]),
                            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.permissionText(data.permission)), 1)
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ]),
                _: 1
              }, 8, ["header"])
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
  ], 64))
}